import { render, staticRenderFns } from "./PVCCustomCover.vue?vue&type=template&id=b505f4c6&scoped=true&"
import script from "./PVCCustomCover.vue?vue&type=script&lang=js&"
export * from "./PVCCustomCover.vue?vue&type=script&lang=js&"
import style0 from "./PVCCustomCover.vue?vue&type=style&index=0&id=b505f4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b505f4c6",
  null
  
)

export default component.exports